export default {"src":"/uk/_next/static/media/playIcon.489b8a9c.svg","height":40,"width":26,"blurWidth":0,"blurHeight":0};